export function LoadingSkeleton(): JSX.Element {
  return <div className="skeleton" aria-busy="true">Loading…</div>;
}
